import React from 'react';
import type { FormFieldProps } from 'semantic-ui-react';
import { SchemaTypes } from '@axiom/types';

import type { IconName } from '../../element/Icon/icon.types';
import { FormField } from '../FormField/FormField';
import type { RawDropdownDirectionType } from '../Dropdown/RawDropdown';

import type {
  RawDropdownTreeProps,
  RawDropdownTreeValueType,
} from './RawDropdownTree';
import { RawDropdownTree } from './RawDropdownTree';

export type DropdownTreeProps = {
  description?: string;
  direction?: RawDropdownDirectionType;
  displayKey: RawDropdownTreeProps['displayKey'];
  disabled?: RawDropdownTreeProps['disabled'];
  icon?: IconName;
  id?: RawDropdownTreeProps['id'];
  label?: React.ReactNode;
  name: RawDropdownTreeProps['name'];
  nestedKey: RawDropdownTreeProps['nestedKey'];
  onBlur?: (value?: RawDropdownTreeValueType) => void;
  onChange?: (value?: RawDropdownTreeValueType) => Promise<unknown> | void;
  onFocus?: (value?: RawDropdownTreeValueType) => void;
  options: RawDropdownTreeProps['options'];
  placeholder?: RawDropdownTreeProps['placeholder'];
  parentOperatesAsDropdownOnly?: RawDropdownTreeProps['parentOperatesAsDropdownOnly'];
  Tooltip?: React.ReactNode;
  valueKey: RawDropdownTreeProps['valueKey'];
};

export const DropdownTree = ({
  description,
  direction,
  displayKey,
  disabled,
  icon,
  id,
  label,
  name,
  nestedKey,
  onBlur = () => {},
  onChange = () => {},
  onFocus = () => {},
  options,
  parentOperatesAsDropdownOnly,
  placeholder,
  Tooltip,
  valueKey,
}: DropdownTreeProps) => {
  return (
    <FormField
      {...{
        description,
        disabled,
        icon,
        id,
        name,
        label,
        onClear: async (v: RawDropdownTreeValueType) => onChange(v),
        Tooltip,
      }}
      renderField={({
        value,
        onBlur: formOnBlur,
        setFieldValue,
        invalid,
        schemaProperty,
      }: {
        value: RawDropdownTreeProps['value'];
      } & FormFieldProps) => (
        <RawDropdownTree
          direction={direction}
          displayKey={displayKey}
          disabled={disabled}
          hideIcon={!!icon}
          id={id}
          invalid={invalid}
          multiple={schemaProperty.type === SchemaTypes.ZodArray}
          name={name}
          nestedKey={nestedKey}
          onBlur={e => {
            onBlur(e.target.value);
            formOnBlur({ ...e, target: { ...e.target, name } });
          }}
          onChange={v => {
            void onChange(v);
            setFieldValue(name, v);
          }}
          onFocus={() => {
            onFocus();
          }}
          options={options}
          parentOperatesAsDropdownOnly={parentOperatesAsDropdownOnly}
          placeholder={placeholder}
          value={value}
          valueKey={valueKey}
        />
      )}
    />
  );
};
